import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from 'axios';

//React export function used to display the shipper address block
export default function ShipperAddress(props) {

    //Setting the states
    const [values, setValues] = useState([]);
    const [collectionvalues, setCollectionValues] = useState([]);
    const [checked, setChecked] = React.useState([false, false]);
    const [hide, setHide] = useState(false);
    const [collectionAddressID, setCollectionAddressID] = useState(0);
    const [defaultCollectionAddress, setDefaultCollectionAddress] = useState("");
    const [defaultValue, setDefaultValue] = useState([]);
    const [shipperAddressID, setShipperAddressID] = useState(0);

    useEffect(() => {
        getDefaultShipper();
        getDefaultCollectionAddress();
    }, []);

    useEffect(() => {
        setDefaultShipperAddressID(defaultValue[0]);
    }, [defaultValue]);

    const getDefaultShipper = () => {
        if (props.ShipperName !== null && props.ShipperName !== undefined) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: props.ShipperName} })
                .then((res) => {
                    setDefaultValue(res.data);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
    };

    const getDefaultCollectionAddress = () => {
        if (props.Addresses !== null && props.Addresses !== undefined) {
            var shp = {};
            var col = {};
            props.Addresses.forEach((address) => {
                if (address.addressUseCode === 'SHP') {
                    shp = address;
                }
                if (address.addressUseCode === 'COL') {
                    col = address;
                }
            });

            if (shp.addressID !== col.addressID) {
                setCollectionAddressID(col.addressID);
                setDefaultCollectionAddress(`${col.organisationName}, ${col.townCity}, ${col.countryCode}`);
                setHide(true);
                setChecked([true, true]);
            }
        }
    };

    const handleChange = (event) => {
        setHide(prev => !prev);
        setChecked([event.target.checked, event.target.checked]);
    };

    const handleShipperAddressID = (newValue) => {
        if (newValue !== null && newValue !== undefined) {
            setShipperAddressID(newValue.id);
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetFullAddressByID`, { params: { Id: newValue.id } })
                .then((res) => {
                    props.contactDetails({ addressId: res.data.id, contacts: res.data.contactDetails });
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
        else {
            props.contactDetails([]);
        }
    };

    const setDefaultShipperAddressID = (newValue) => {
        if (newValue !== null && newValue !== undefined) {
            setShipperAddressID(newValue.id);
            handleShipperAddressID(newValue)
        }
    };

    const handleCollectionAddressID = (newValue) => {
        if (newValue !== null && newValue !== undefined) {
            setCollectionAddressID(newValue.id);
        }
    };

    //On change handle the get address request
    const handleShipperAddress = ({ target }) => {
        if (target !== undefined) {
            const { value } = target;
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: value } })
                .then((res) => {
                    setValues(res.data);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
    };

    //On change handle the get address request
    const handleCollectionAddress = ({ target }) => {
        if (target !== undefined) {
            setCollectionValues([]);
            const { value } = target;
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetAddress`, { params: { searchField: value } })
                .then((res) => {
                    setCollectionValues(res.data);
                    setCollectionAddressID(res.data[0].id);
                })
                .catch((e) => {
                    console.log('error happened');
                });
        }
    };

    //Render the dropdowns onto the screen
    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={12}>
                <input type="hidden" name="shipperAddressID" id="deliveryAddressID" value={shipperAddressID} />
                <input type="hidden" name="collectionAddressID" id="collectionAddressID" value={collectionAddressID} />
                    <Autocomplete
                        size="small"
                        disablePortal
                        id="Shipper"
                        options={values}
                        onInputChange={(event) => handleShipperAddress(event || {})}
                        onChange={(event, newValue) => {
                            handleShipperAddressID(newValue)
                        }}
                        defaultValue={props.ShipperName}
                        sx={{ marginTop: 1, width: '100%' }}
                        renderInput={(params) => <TextField size="small" {...params} id="Shipper" name="Shipper" label="Shipper" required />}
                    />
                  <FormControlLabel
                        label="Different Collection Address"
                        sx={{ marginLeft: '2px' }}
                        control={<Checkbox checked={checked[0]} onChange={handleChange} name="cbCollectionAddress" id="cbCollectionAddress" />}
                   />
                  {hide && <Autocomplete
                        size="small"
                        disablePortal
                        id="collectionAddress"
                        options={collectionvalues}
                        onInputChange={(event) => handleCollectionAddress(event || {})}
                        defaultValue={defaultCollectionAddress}
                        sx={{  marginTop: 1 }}
                        renderInput={(params) => <TextField size="small" {...params} id="collectionAddress" name="collectionAddress" label="Collection Address" required />}
                    />}
            </GridItem>
            </GridContainer>
        </React.Fragment>
    );
}

